export default "__VITE_ASSET__BSujJxI8__"